<!-- modular program completion html start -->
<ng-container *ngIf="activationInfo?.isNewActivation">
  <section id="main-section" *ngIf="activationInfo && !showHideDownload">
    <div class="w-100"
      *ngIf="(activationInfo?.enableProgramCertificate && activationInfo?.showProgramPerformanceReport) || (activationInfo?.showProgramPerformanceReport && !activationInfo?.enableProgramCertificate)">
      <div class="d-flex program-comp--banner">
        <div class="program-comp--banner-inner">
          <p>Nice Job,</p>
          <h3 class="text-capitalize">{{user?.firstName}} {{user?.lastName}}!</h3>
          <p> <span class="nice-job">Congratulations on completing
              <strong>{{activationInfo?.title}}</strong>!</span>
            <ng-container
              *ngIf="activationInfo?.enableProgramCertificate && !isProgramCompletionDatePassed">
              Claim your
              certificate with pride.</ng-container>
            <ng-container
              *ngIf="(activationInfo?.enableProgramCertificate && activationInfo?.showProgramPerformanceReport) || (activationInfo?.showProgramPerformanceReport && !activationInfo?.enableProgramCertificate)">
              You can <ng-container
                *ngIf="activationInfo?.enableProgramCertificate && !isProgramCompletionDatePassed">
                also
              </ng-container> download the transcript for a comprehensive view
              of your performance in the program.</ng-container>
          </p>
        </div>
      </div>
      <article class="program-comp">
        <header class="d-flex program-comp__header">
          <div class="d-flex program-comp__header--ques cursor-pointer" (click)="showPopupModal()">
            ?
          </div>
        </header>

        <!-- Congrats section with progress section-->
        <div class="program-comp__main d-flex">
          <!-- <div data-pop="pop-in" class="program-comp__popup">
                        <img src="assets/images/ribbons-desktop.svg" alt="" class="hide-on-mobile" />
                        <img src="assets/images/ribbons-mobile.svg" alt="" class="ribbon--big show-on-desktop" />
                    </div> -->
          <!-- <div data-pop="pop-in" class="program-comp__popup popup--mob show-on-desktop">
                        <img src="assets/images/orrange-ribbon-mob.png" alt="" class="ribbon--single" />
                    </div> -->

          <div id="congo__main" class="program-comp__cont light-bg w-100 d-flex">


            <div class="program-comp__card">
              <div class="progress--bar">
                <svg>
                  <circle cx="105" cy="105" r="100"></circle>
                  <circle cx="105" cy="105" r="100" style="--percent: {{score | number: '1.0-0'}}">
                  </circle>
                </svg>
                <div class="number">
                  <p> Your Score:</p>
                  <h3>
                    <span id="scoreCounter">{{score | number: '1.0-0'}}</span>%
                  </h3>
                </div>
                <!-- <div class="progress--bar__grey"></div>
                                <div class="progress--bar-color" [ngClass]="{
                                'progress--bar-color-exce': activationData[0]?.programPercentage > 60,
                                'progress--bar-color-good': activationData[0]?.programPercentage > 30 && activationData[0]?.programPercentage <= 60,
                                'progress--bar-color-poor': activationData[0]?.programPercentage <= 30
                            }"></div> -->
                <!-- <div class="progress--bar-color progress--bar-color-poor"></div>
                            <div class="progress--bar-color progress--bar-color-exce"></div> -->
              </div>
              <div class="program-comp__card--button">
                <a (click)="viewScoreBreakup()" class="cursor-pointer">View Score Breakup</a>
              </div>
            </div>
            <div class="program-comp__card"
              *ngIf="activationInfo && activationInfo.programCertificate && activationInfo.programCertificate.certificateId && activationInfo?.enableProgramCertificate && !isProgramCompletionDatePassed">
              <img src="/assets/images/upgradRed/upgrad_seal.png" />
              <div class="program-comp__card--button">
                <a (click)="goToCertificate(activationInfo?.programCertificate.certificateId)" class="cursor-pointer">
                  View certificate
                </a>
              </div>
            </div>
            <div class="program-comp__card">
              <div class="program-comp__card--download">
                <span class="material-symbols-outlined">
                  download
                </span>
              </div>
              <div class="program-comp__card--button">

                <a *ngIf="activationInfo?.showProgramPerformanceReport" class="cursor-pointer"
                  (click)="generatePdf()">
                  download transcript
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- program completion topics -->
        <ng-container *ngIf="activationInfo.showProgramPerformanceReport">
          <div class="proc__topics d-flex viewScoreBreakup" *ngFor="let item of activationInfo.programBloScore">
            <div class="proc__topics-cont d-flex">
              <div class="proc__topics-cont--left">
                <h3 [innerHTML]="item.shortStatement"></h3>
                <h5 [innerHTML]="item.statement"></h5>
              </div>
              <div class="proc__topics-cont--right">
                <div class="proc__topics-cont--right-top">Points Earned
                  <!-- <span class="final--result">{{item.gainedMarks}}/{{item.totalMarks}}</span> -->
                  <span class="final--result">{{(item.gainedMarks/item.totalMarks) | percent:
                    '1.0-0'}}</span>
                </div>
                <!-- Progres Bar -->
                <div class="points--bar-main">
                  <div class="points--bar-color" [ngStyle]="{'width': (item?.gainedMarks/item?.totalMarks*100) + '%'} "
                    [ngClass]="{
                                    'points--bar-color-excel': (item?.gainedMarks/item?.totalMarks*100) > 60,
                                    'points--bar-color-good':  ((item?.gainedMarks/item?.totalMarks*100) <= 60) && ((item?.gainedMarks/item?.totalMarks*100) > 30),
                                    'points--bar-color-poor':  (item?.gainedMarks/item?.totalMarks*100) <= 30 }"></div>
                  <div class="points--bar-bg" [ngClass]="{
                                    'points--bar-color-excel': (item?.gainedMarks/item?.totalMarks*100) > 60,
                                    'points--bar-color-good':  ((item?.gainedMarks/item?.totalMarks*100) <= 60) && ((item?.gainedMarks/item?.totalMarks*100) > 30),
                                    'points--bar-color-poor':  (item?.gainedMarks/item?.totalMarks*100) <= 30 }"></div>
                </div>
              </div>
            </div>
            <div class="proc__topics-bottom d-flex">
              <ng-container *ngFor="let course of item.courses; let i=index">
                <div class="proc__topics-bottom--list">{{course.courseName | titlecase}}
                  <span class="result">{{course.gainedMarks}}/{{course.totalMarks}}</span>
                </div>
                <div class="proc__topics--line" *ngIf="i < item.courses.length-1"></div>
              </ng-container>

              <!-- <div class="proc__topics-bottom--list">Unleashing Creativity
                            <span class="result">00/30</span>
                        </div>
                        <div class="proc__topics--line"></div>
                        <div class="proc__topics-bottom--list">Practicing Excellence
                            <span class="result">30/40</span>
                        </div> -->
            </div>
          </div>
        </ng-container>

        <!-- program completion topics end -->
      </article>
    </div>
  </section>

  <!-- to download pdf  -->
  <ng-container *ngIf="activationData && showHideDownload">
    <div id="programPdf" #programPdf>
        <article class="program-comp program-comp--pdf">

            <!-- Congrats section with progress section-->
            <div class="program-comp__main d-flex">
                <div id="congo__main" class="program-comp__cont--for-pdf program-comp__cont1 grey-bg w-100 d-flex">

                    <div class="program-comp__cont--left">
                        <h4>Nice Job,</h4>
                        <h2 class="text-capitalize">{{user?.firstName}} {{user?.lastName}}!</h2>
                        <p>Congratulations on completing {{activationData[0]?.program?.activation?.title}}.</p>
                    </div>
                    <div class="program-comp__cont--ryt program-comp__cont--ryt--pdf">
                        <h3>Your Score</h3>
                        <div class="progress--bar">
                            <div class="progress--bar__inner">
                                <span id="scoreCounter">{{score | number: '1.0-0'}}</span>%
                            </div>
                            <div class="progress--bar__grey"></div>
                            <div class="progress--bar-color" [ngClass]="{
                                'progress--bar-color-exce': activationInfo?.programPercentage > 60,
                                'progress--bar-color-good': activationInfo?.programPercentage > 30 && activationInfo?.programPercentage <= 60,
                                'progress--bar-color-poor': activationInfo?.programPercentage <= 30
                            }"></div>
                            <!-- <div class="progress--bar-color progress--bar-color-poor"></div>
                            <div class="progress--bar-color progress--bar-color-exce"></div> -->
                        </div>
                    </div>
                </div>
            </div>
            <p class="score-heading pd-t40">Your Score Breakup</p>
            <!-- program completion topics -->

            <div class="proc__topics d-flex viewScoreBreakup"
                *ngFor="let item of activationData[0].programBloScore">
                <div class="proc__topics-cont d-flex">
                    <div class="proc__topics-cont--left">
                        <h3 [innerHTML]="item.shortStatement"></h3>
                        <h5 [innerHTML]="item.statement"></h5>
                    </div>
                    <div class="proc__topics-cont--right">
                        <div class="proc__topics-cont--right-top">Points Earned
                            <!-- <span class="final--result">{{item.gainedMarks}}/{{item.totalMarks}}</span> -->
                            <span class="final--result">{{(item.gainedMarks/item.totalMarks) | percent: '1.0-0'}}</span>
                        </div>
                        <!-- Progres Bar -->
                        <div class="points--bar-main">
                            <div class="points--bar-color"
                                [ngStyle]="{'width': (item?.gainedMarks/item?.totalMarks*100) + '%'} " [ngClass]="{
                                    'points--bar-color-excel': (item?.gainedMarks/item?.totalMarks*100) > 60,
                                    'points--bar-color-good':  ((item?.gainedMarks/item?.totalMarks*100) <= 60) && ((item?.gainedMarks/item?.totalMarks*100) > 30),
                                    'points--bar-color-poor':  (item?.gainedMarks/item?.totalMarks*100) <= 30 }">
                            </div>
                            <div class="points--bar-bg" [ngClass]="{
                                    'points--bar-color-excel': (item?.gainedMarks/item?.totalMarks*100) > 60,
                                    'points--bar-color-good':  ((item?.gainedMarks/item?.totalMarks*100) <= 60) && ((item?.gainedMarks/item?.totalMarks*100) > 30),
                                    'points--bar-color-poor':  (item?.gainedMarks/item?.totalMarks*100) <= 30 }">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="proc__topics-bottom d-flex">
                    <ng-container *ngFor="let course of item.courses; let i=index">
                        <div class="proc__topics-bottom--list">{{course.courseName | titlecase}}
                            <span class="result">{{course.gainedMarks}}/{{course.totalMarks}}</span>
                        </div>
                        <div class="proc__topics--line" *ngIf="i < item.courses.length-1"></div>
                    </ng-container>

                    <!-- <div class="proc__topics-bottom--list">Unleashing Creativity
                            <span class="result">00/30</span>
                        </div>
                        <div class="proc__topics--line"></div>
                        <div class="proc__topics-bottom--list">Practicing Excellence
                            <span class="result">30/40</span>
                        </div> -->
                </div>
            </div>

            <!-- program completion topics end -->
        </article>
    </div>
</ng-container>
  <div class="position-relative" *ngIf="showHideLoader">
    <div class="d-flex align-items-center justify-content-center certificate-loader">
      <div>
        <img class="mx-auto loader-gif" src="assets/images/upgradRed/upgradLoader.gif" style="margin: 0 auto;">
        <div>Your report is downloading...</div>
      </div>
    </div>
  </div>

  <!-- <div class="position-relative" *ngIf="showHideLoaderInit">
        <div class="d-flex align-items-center justify-content-center certificate-loader">
            <div>
                <img class="mx-auto" src="assets/images/upgradRed/upgradLoader.gif" style="margin: 0 auto;">
            </div>
        </div>
    </div> -->
  <app-popup-modal *ngIf="showHidePopupModal" (hidePopupModal)="hidePopup($event)"></app-popup-modal>
</ng-container>
<!-- modular program completion html end -->

<!-- old program completion html start -->
<ng-container *ngIf="activationInfo && !activationInfo?.isNewActivation">
  <section id="main-section" class="pd-t40 pd-b40 pd-l40 pd-r40 pd-sm-20 lightgrey-bg"
    *ngIf="activationInfo && !showHideDownload">
    <div class="smallContainer mg-auto">
      <article class="program-comp">
        <header class="d-flex program-comp__header">
          <div class="d-flex program-comp__header--ques cursor-pointer" (click)="showPopupModal()">
            ?
          </div>
        </header>

        <!-- Congrats section with progress section-->
        <div class="program-comp__main d-flex">
          <div data-pop="pop-in" class="program-comp__popup">
            <img src="assets/images/ribbons-desktop.svg" alt="" class="hide-on-mobile" />
            <img src="assets/images/ribbons-mobile.svg" alt="" class="ribbon--big show-on-desktop" />
          </div>
          <div data-pop="pop-in" class="program-comp__popup popup--mob show-on-desktop">
            <img src="assets/images/orrange-ribbon-mob.png" alt="" class="ribbon--single" />
          </div>

          <div id="congo__main" class="program-comp__cont light-bg w-100 d-flex">

            <div class="program-comp__cont--left">
              <h4>Nice Job,</h4>
              <h2 class="text-capitalize">{{user?.firstName}} {{user?.lastName}}!</h2>
              <p><span class="nice-job">Congratulations on completing
                  <strong>{{activationInfo?.title}}</strong>.</span></p>
            </div>
            <div class="program-comp__cont--ryt">
              <h3>Your Program Score</h3>
              <div class="progress--bar">
                <div class="progress--bar__inner">
                  <span id="scoreCounter">{{score | number: '1.0-0'}}</span>%
                </div>
                <div class="progress--bar__grey"></div>
                <div class="progress--bar-color" [ngClass]="{
                                'progress--bar-color-exce': activationInfo?.programPercentage > 60,
                                'progress--bar-color-good': activationInfo?.programPercentage > 30 && activationInfo?.programPercentage <= 60,
                                'progress--bar-color-poor': activationInfo?.programPercentage <= 30
                            }"></div>
                <!-- <div class="progress--bar-color progress--bar-color-poor"></div>
                            <div class="progress--bar-color progress--bar-color-exce"></div> -->
              </div>
              <div class="score--breakup">
                <a (click)="viewScoreBreakup()" class="cursor-pointer">View Score Breakup</a>
              </div>
            </div>
          </div>
        </div>
        <div class="program-comp__claim-text pd-t70 pd-b40">
          <ng-container *ngIf="!isProgramCompletionDatePassed">Claim your certificate with pride.
          </ng-container> You can <ng-container *ngIf="!isProgramCompletionDatePassed">also</ng-container>
          download the transcript for a comprehensive view
          of your performance in the program.
        </div>
        <div class="program-comp__claim-buttons d-flex mg-t15">
          <button class="light-color link-no-underline blue--button pd-t10 pd-b10" (click)="generatePdf()">
            <span class="icon-download-icon"></span> DOWNLOAD TRANSCRIPT
          </button>
          <button
            *ngIf="(activationInfo && activationInfo.programCertificate && activationInfo.programCertificate.certificateId && !isProgramCompletionDatePassed)"
            (click)="goToCertificate(activationInfo.programCertificate.certificateId)"
            class="light-color link-no-underline blue--button pd-t10 pd-b10 mg-l40">
            <span class="icon-medal"></span> VIEW CERTIFICATE
          </button>
        </div>
        <!-- program completion topics -->

        <div class="proc__topics d-flex viewScoreBreakup" *ngFor="let item of activationInfo.programBloScore">
          <div class="proc__topics-cont d-flex">
            <div class="proc__topics-cont--left">
              <h3 [innerHTML]="item.shortStatement"></h3>
              <h5 [innerHTML]="item.statement"></h5>
            </div>
            <div class="proc__topics-cont--right">
              <div class="proc__topics-cont--right-top">Points Earned
                <!-- <span class="final--result">{{item.gainedMarks}}/{{item.totalMarks}}</span> -->
                <span class="final--result">{{(item.gainedMarks/item.totalMarks) | percent:
                  '1.0-0'}}</span>
              </div>
              <!-- Progres Bar -->
              <div class="points--bar-main">
                <div class="points--bar-color" [ngStyle]="{'width': (item?.gainedMarks/item?.totalMarks*100) + '%'} "
                  [ngClass]="{
                                'points--bar-color-excel': (item?.gainedMarks/item?.totalMarks*100) > 60,
                                'points--bar-color-good':  ((item?.gainedMarks/item?.totalMarks*100) <= 60) && ((item?.gainedMarks/item?.totalMarks*100) > 30),
                                'points--bar-color-poor':  (item?.gainedMarks/item?.totalMarks*100) <= 30 }"></div>
                <div class="points--bar-bg" [ngClass]="{
                                'points--bar-color-excel': (item?.gainedMarks/item?.totalMarks*100) > 60,
                                'points--bar-color-good':  ((item?.gainedMarks/item?.totalMarks*100) <= 60) && ((item?.gainedMarks/item?.totalMarks*100) > 30),
                                'points--bar-color-poor':  (item?.gainedMarks/item?.totalMarks*100) <= 30 }"></div>
              </div>
            </div>
          </div>
          <div class="proc__topics-bottom d-flex">
            <ng-container *ngFor="let course of item.courses; let i=index">
              <div class="proc__topics-bottom--list">{{course.courseName | titlecase}}
                <span class="result">{{course.gainedMarks}}/{{course.totalMarks}}</span>
              </div>
              <div class="proc__topics--line" *ngIf="i < item.courses.length-1"></div>
            </ng-container>

            <!-- <div class="proc__topics-bottom--list">Unleashing Creativity
                        <span class="result">00/30</span>
                    </div>
                    <div class="proc__topics--line"></div>
                    <div class="proc__topics-bottom--list">Practicing Excellence
                        <span class="result">30/40</span>
                    </div> -->
          </div>
        </div>
        <!-- program completion topics end -->
      </article>
    </div>
  </section>

  <!-- to download pdf  -->
  <ng-container *ngIf="activationData && showHideDownload">
    <div id="programPdf" #programPdf>
      <article class="program-comp program-comp--pdf">

        <!-- Congrats section with progress section-->
        <div class="program-comp__main d-flex">
          <div id="congo__main" class="program-comp__cont program-comp__cont1 grey-bg w-100 d-flex">

            <div class="program-comp__cont--left">
              <h4>Nice Job,</h4>
              <h2 class="text-capitalize">{{user?.firstName}} {{user?.lastName}}!</h2>
              <p><span class="nice-job">Congratulations on completing
                  <strong>{{activationInfo?.title}}</strong>.</span></p>
            </div>
            <div class="program-comp__cont--ryt program-comp__cont--ryt--pdf">
              <h3>Your Program Score</h3>
              <div class="progress--bar">
                <div class="progress--bar__inner">
                  <span id="scoreCounter">{{score | number: '1.0-0'}}</span>%
                </div>
                <div class="progress--bar__grey"></div>
                <div class="progress--bar-color" [ngClass]="{
                                    'progress--bar-color-exce': activationInfo?.programPercentage > 60,
                                    'progress--bar-color-good': activationInfo?.programPercentage > 30 && activationInfo?.programPercentage <= 60,
                                    'progress--bar-color-poor': activationInfo?.programPercentage <= 30
                                }"></div>
                <!-- <div class="progress--bar-color progress--bar-color-poor"></div>
                                <div class="progress--bar-color progress--bar-color-exce"></div> -->
              </div>
            </div>
          </div>
        </div>
        <p class="score-heading pd-t40">Your Score Breakup</p>
        <!-- program completion topics -->

        <div class="proc__topics d-flex viewScoreBreakup" *ngFor="let item of activationInfo?.programBloScore">
          <div class="proc__topics-cont d-flex">
            <div class="proc__topics-cont--left">
              <h3 [innerHTML]="item.shortStatement"></h3>
              <h5 [innerHTML]="item.statement"></h5>
            </div>
            <div class="proc__topics-cont--right">
              <div class="proc__topics-cont--right-top">Points Earned
                <!-- <span class="final--result">{{item.gainedMarks}}/{{item.totalMarks}}</span> -->
                <span class="final--result">{{(item.gainedMarks/item.totalMarks) | percent:
                  '1.0-0'}}</span>
              </div>
              <!-- Progres Bar -->
              <div class="points--bar-main">
                <div class="points--bar-color" [ngStyle]="{'width': (item?.gainedMarks/item?.totalMarks*100) + '%'} "
                  [ngClass]="{
                                    'points--bar-color-excel': (item?.gainedMarks/item?.totalMarks*100) > 60,
                                    'points--bar-color-good':  ((item?.gainedMarks/item?.totalMarks*100) <= 60) && ((item?.gainedMarks/item?.totalMarks*100) > 30),
                                    'points--bar-color-poor':  (item?.gainedMarks/item?.totalMarks*100) <= 30 }"></div>
                <div class="points--bar-bg" [ngClass]="{
                                    'points--bar-color-excel': (item?.gainedMarks/item?.totalMarks*100) > 60,
                                    'points--bar-color-good':  ((item?.gainedMarks/item?.totalMarks*100) <= 60) && ((item?.gainedMarks/item?.totalMarks*100) > 30),
                                    'points--bar-color-poor':  (item?.gainedMarks/item?.totalMarks*100) <= 30 }"></div>
              </div>
            </div>
          </div>
          <div class="proc__topics-bottom d-flex">
            <ng-container *ngFor="let course of item.courses; let i=index">
              <div class="proc__topics-bottom--list">{{course.courseName | titlecase}}
                <span class="result">{{course.gainedMarks}}/{{course.totalMarks}}</span>
              </div>
              <div class="proc__topics--line" *ngIf="i < item.courses.length-1"></div>
            </ng-container>

            <!-- <div class="proc__topics-bottom--list">Unleashing Creativity
                            <span class="result">00/30</span>
                        </div>
                        <div class="proc__topics--line"></div>
                        <div class="proc__topics-bottom--list">Practicing Excellence
                            <span class="result">30/40</span>
                        </div> -->
          </div>
        </div>

        <!-- program completion topics end -->
      </article>
    </div>
  </ng-container>
  <div class="position-relative" *ngIf="showHideLoader">
    <div class="d-flex align-items-center justify-content-center certificate-loader">
      <div>
        <img class="mx-auto loader-gif" src="assets/images/upgradRed/upgradLoader.gif" style="margin: 0 auto;">
        <div>Your report is downloading...</div>
      </div>
    </div>
  </div>

  <!-- <div class="position-relative" *ngIf="showHideLoaderInit">
        <div class="d-flex align-items-center justify-content-center certificate-loader">
            <div>
                <img class="mx-auto" src="assets/images/upgradRed/upgradLoader.gif" style="margin: 0 auto;">
            </div>
        </div>
    </div> -->
  <app-popup-modal *ngIf="showHidePopupModal" (hidePopupModal)="hidePopup($event)"></app-popup-modal>
</ng-container>
<!-- old program completion html end -->

<!-- show loader start -->
<div class="position-relative" *ngIf="showHideLoaderInit">
  <div class="d-flex align-items-center justify-content-center certificate-loader">
    <div>
      <img class="mx-auto loader-gif" src="assets/images/upgradRed/upgradLoader.gif" style="margin: 0 auto;">
    </div>
  </div>
</div>
<!-- show loader end -->
